import { SettingPage } from "@/features/system-setting/pages/Setting";
import { SettingFilterCacheProvider } from "@/features/system-setting/provider/SettingFilterCacheProvider";

const Setting = () => {
  return (
    <SettingFilterCacheProvider>
      <SettingPage />
    </SettingFilterCacheProvider>
  );
};

export default Setting;
